import { makeStyles } from "@mui/styles"

export const textFontSize = '1.4rem'

const styles = makeStyles(() => ({
  bold: {
    fontWeight: 550,
  },
  alertContainer: {
    marginTop: 15,
  },
  buttonsContainer: {
    display: 'flex',
    margin: '10px 0',
    flexDirection: 'column',
  },
  dbInfoDiv: {
    margin: '15px 0',
  },
  textWithbuttonDiv: {
    margin: '10px 0',
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
  },
  buttonStyle: { width: 250, fontSize: '1.2rem' },
}))

export default styles
